import { useEffect, useState } from 'react'
import { getQueueByTable, subscribeQueueChanges } from '../lib/mutationQueue'

export function useQueueByTable(table) {
  const [pending, setPending] = useState([])

  useEffect(() => {
    let cancelled = false
    const refresh = async () => {
      const items = await getQueueByTable(table)
      if (!cancelled) setPending(items)
    }
    refresh()
    const unsub = subscribeQueueChanges(refresh)
    return () => {
      cancelled = true
      unsub()
    }
  }, [table])

  return pending
}

export function useQueueAll() {
  const [pending, setPending] = useState([])

  useEffect(() => {
    let cancelled = false
    const refresh = async () => {
      const { getQueue } = await import('../lib/mutationQueue')
      const items = await getQueue()
      if (!cancelled) setPending(items)
    }
    refresh()
    const unsub = subscribeQueueChanges(refresh)
    return () => {
      cancelled = true
      unsub()
    }
  }, [])

  return pending
}
